export enum DataHooks {
  Root = 'header',
  Title = 'header-title',
  Subtitle = 'header-subtitle',
  tagLine = 'header-tagline',
}

export const HEADER_TITLE_ID = DataHooks.Title;
